/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // custom search position
  document.addEventListener('DOMContentLoaded', () => {
    // Select all matching predictive search elements and input fields
    const predictiveSearchElements = document.querySelectorAll('.header__desktop__upper .predictive-search--empty, .header_mobile_search .predictive-search--empty');
    const searchInputs = document.querySelectorAll('.header__desktop__upper .search-form input#SearchInput--, .header_mobile_search .search-form input#SearchInput--');
  
    // Hide all predictive search elements initially
    predictiveSearchElements.forEach(element => {
      element.style.display = 'none'; // Hide initially
    });
  
    // Function to show predictive search
    const showPredictiveSearch = () => {
      predictiveSearchElements.forEach(element => {
        element.style.display = 'block'; // Show predictive search
      });
    };
  
    // Function to hide predictive search
    const hidePredictiveSearch = () => {
      predictiveSearchElements.forEach(element => {
        element.style.display = 'none'; // Hide predictive search
      });
    };
  
    // Add focus event listeners to inputs to show predictive search
    searchInputs.forEach(input => {
      input.addEventListener('focus', () => {
        showPredictiveSearch(); // Show predictive search on focus
  
        // Add a click listener to detect clicks outside
        const clickOutsideHandler = (event) => {
          const isClickInside = [...searchInputs, ...predictiveSearchElements].some(element =>
            element.contains(event.target)
          );
  
          if (!isClickInside) {
            hidePredictiveSearch(); // Hide predictive search when clicked outside
            document.removeEventListener('click', clickOutsideHandler); // Remove listener
          }
        };
  
        document.addEventListener('click', clickOutsideHandler);
      });
    });
  });
})();

// ============================================================================
// ATC (.atc-default) / Request-a-Quote (.omgrfq-button) mutual exclusion
//
// GPO (Globo Product Options) clones the ATC button and stamps two classes:
//   .gpo-clone-atc-button    – the visible clone GPO controls
//   .gpo-original-atc-button – the original button GPO hides
//
// Decision tree (evaluated in order):
//
//   1. GPO clone present AND NOT a quote template
//      → Purchasable product. GPO owns ATC visibility — don't interfere.
//        Hide .omgrfq-button only.
//
//   2. Quote template (data-add-to-cart-text absent on .btn__text, or body
//      carries class template-product-request-a-quote) — regardless of GPO
//      → Hide EVERY .atc-default button with inline display:none !important
//        (covers both the normal button and any disabled [disabled] variant).
//        Also hide the sold-out modal. Reveal .omgrfq-button alone.
//
//   3. No GPO clone, not a quote template (regular product without GPO)
//      → Product should still use the omgrfq quote flow.
//        Hide .atc-default with inline display:none !important.
//        Reveal .omgrfq-button.
//
// Rules 2 and 3 share the same action — inline !important is required to
// override the theme's own display:block !important set by ProductForm JS.
//
// Observer: debounced childList on the section catches the async .omgrfq-button
// injection and the GPO clone insertion. Staggered timeouts cover the full
// app init window. No attribute observer — that pattern fights the theme's JS
// and causes a feedback loop.
// ============================================================================
(function () {
  'use strict';

  // Primary signal: data-rfq-product="true|false" stamped by the Liquid
  // evaluation of rfq_condition blocks in sections/product.liquid.
  // Fallback (for pages not yet updated or quick-view overlays): absence of
  // data-add-to-cart-text on .btn__text, or body class from the template.
  function sectionIsQuote(section) {
    var attr = section.dataset.rfqProduct;
    if (attr === 'true')  return true;
    if (attr === 'false') return false;

    var atcBtn = section.querySelector('.atc-default');
    if (atcBtn) {
      var label = atcBtn.querySelector('.btn__text');
      if (label) return !label.hasAttribute('data-add-to-cart-text');
    }
    return document.body.classList.contains('template-product-request-a-quote');
  }

  function applyVisibility(section) {
    var omgrfqBtn   = section.querySelector('.omgrfq-button');
    var gpoCloneBtn = section.querySelector('.atc-default.gpo-clone-atc-button');
    var isQuote     = sectionIsQuote(section);
    var submitWrap  = section.querySelector('.product__submit');

    // GPO temporarily removes its clone button while re-rendering after an
    // option change. Latch the flag so a brief absence doesn't flip us to
    // Scenario 2/3 and hide the ATC mid-interaction.
    if (gpoCloneBtn) section._gpoCloneSeen = true;

    if ((gpoCloneBtn || section._gpoCloneSeen) && !isQuote) {
      // ── Scenario 1: purchasable product with GPO ──────────────────────────
      // GPO manages the clone's visibility — don't interfere with .product__submit.
      // Restore it if we previously hid it, and just hide .omgrfq-button.
      if (submitWrap) submitWrap.style.removeProperty('display');
      if (omgrfqBtn)  omgrfqBtn.style.setProperty('display', 'none', 'important');

    } else if (isQuote) {
      // ── Scenario 2 & 3: confirmed quote/RFQ product ───────────────────────
      // Hide .product__submit via the parent wrapper (children's display:block
      // !important from GPO/theme can't escape a hidden parent). Show omgrfq.
      if (submitWrap) submitWrap.style.setProperty('display', 'none', 'important');
      if (omgrfqBtn)  omgrfqBtn.style.removeProperty('display');

    } else {
      // ── Scenario 4: regular product — no GPO, not a quote product ─────────
      // Neither app manages this product. Restore the ATC button so the theme
      // can display it normally, and hide .omgrfq-button if present.
      if (submitWrap) submitWrap.style.removeProperty('display');
      if (omgrfqBtn)  omgrfqBtn.style.setProperty('display', 'none', 'important');
    }

    // Trigger the CSS fade-in transition. requestAnimationFrame ensures the
    // browser commits one frame at opacity:0 (from the :not(.rfq-ready) rule)
    // before rfq-ready is added, so the transition actually fires.
    if (!section.classList.contains('rfq-ready')) {
      requestAnimationFrame(function () {
        section.classList.add('rfq-ready');
      });
    }
  }

  function watchSection(section) {
    if (section._rfqInit) return;
    section._rfqInit = true;

    // Debounced childList observer: collapses rapid-fire mutations from GPO
    // inserting its clone / Vue app injecting .omgrfq-button into one call.
    var debounceTimer;
    var mo = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { applyVisibility(section); }, 50);
    });
    mo.observe(section, { childList: true, subtree: true });
    section._rfqObserver = mo;


    // Immediate pass + staggered passes covering the full app init window:
    //   150ms  – after GPO first render / clone insertion
    //   600ms  – after heavier app scripts settle
    //   1100ms – after theme's ~1000ms re-init pass
    //   1800ms – after theme's 1500ms re-init pass
    //   2600ms – safety net for anything slow
    applyVisibility(section);
    [150, 600, 1100, 1800, 2600].forEach(function (ms) {
      setTimeout(function () { applyVisibility(section); }, ms);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="product"]').forEach(watchSection);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  // Catch sections mounted after DOMContentLoaded (quick-view overlays etc.)
  setTimeout(initAll, 400);
})();

// ============================================================================
// Variant selection unlock ("mimic Dawn")
//
// The theme marks an option value as sold-out + disabled when the FULL current
// combination (all selections, with just this value swapped in) doesn't match a
// real variant — e.g. Loft 9.0° is blocked because the current Shaft "Extra
// Stiff" only exists for 8.0°. That leaves valid, in-stock variants (Right Hand
// + 9.0° with a different shaft) completely unreachable, which is the reported
// "can't select any other variants" bug.
//
// Dawn keeps every option clickable and re-resolves the variant on each change.
// We replicate that: clicking a blocked value navigates to the best matching
// IN-STOCK variant's URL (?variant=ID). The server then re-renders the product
// with that variant selected — correct options, price, stock and ATC state — so
// the outcome is always correct regardless of what the theme/apps do in-page.
// This is the reliable equivalent of Dawn's background fetch + DOM swap.
//
// Available options (normal, not blocked) are left to the theme's own in-page
// handler, so switching shafts within a valid loft stays instant with no reload.
// ============================================================================
(function () {
  'use strict';

  function getVariants(container) {
    var el = container.querySelector('[data-product-json]');
    if (!el) return null;
    try { return JSON.parse(el.innerHTML).variants; } catch (e) { return null; }
  }

  function getOptionGroups(container) {
    return Array.from(container.querySelectorAll('[data-option-position]'))
      .sort(function (a, b) {
        return parseInt(a.getAttribute('data-option-position'), 10) -
               parseInt(b.getAttribute('data-option-position'), 10);
      });
  }

  // Selections for the options BEFORE the one being changed (kept fixed).
  function getUpstream(optionGroups, changedPosition) {
    return optionGroups.map(function (group, idx) {
      if (idx + 1 >= changedPosition) return null;
      var checked = group.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value;
      var hidden = group.querySelector('[data-popout-input]');
      return hidden ? hidden.value : null;
    });
  }

  // Find a variant matching the upstream selections + the newly clicked value.
  // Prefer the first IN-STOCK (available) match so we land on a purchasable
  // variant; fall back to the first match of any stock level so the option is
  // still reachable (and shows sold-out) if none are in stock.
  function findTargetVariant(changedPosition, newValue, upstream, variants) {
    var fallback = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var ok = true;
      for (var j = 0; j < upstream.length; j++) {
        if (upstream[j] !== null && v.options[j] !== upstream[j]) { ok = false; break; }
      }
      if (ok && v.options[changedPosition - 1] === newValue) {
        if (v.available) return v;          // in-stock match — best choice
        if (!fallback) fallback = v;        // remember first match as fallback
      }
    }
    return fallback;
  }

  // Dawn keeps "unavailable" options clickable (it only adds a styling class,
  // never the real disabled attribute). Broadcast injects a real
  // disabled="disabled" at runtime AND its CSS sets pointer-events:none on the
  // sold-out spans/labels, which swallows clicks entirely. Undo BOTH here via
  // inline styles (which beat any cached stylesheet) so the options behave like
  // Dawn's — clickable.
  //
  // Styling: an option greyed by the theme is restored to the normal, selectable
  // look ONLY when an IN-STOCK variant exists for the current upstream selection
  // + that value. Out-of-stock combinations (variant exists but 0 stock) and
  // non-existent combinations stay greyed, so shoppers can tell what's available
  // without clicking. Done with inline styles so it works regardless of
  // stylesheet caching. Re-runs on init, timed passes, and on class re-stamps.
  function unblockOptions(container, variants) {
    var optionGroups = getOptionGroups(container);

    container.querySelectorAll('input[data-single-option-selector]').forEach(function (input) {
      if (input.hasAttribute('disabled')) input.removeAttribute('disabled');
      input.style.setProperty('pointer-events', 'auto', 'important');

      var span = input.closest('.radio__button, .swatch__button');
      if (span) span.style.setProperty('pointer-events', 'auto', 'important');

      var label = input.nextElementSibling;
      if (!label || label.tagName !== 'LABEL') return;
      label.style.setProperty('pointer-events', 'auto', 'important');
      label.style.setProperty('cursor', 'pointer', 'important');

      var isBlocked = input.classList.contains('sold-out') ||
                      input.classList.contains('unavailable');

      // Styling only: show the option as normal when an IN-STOCK variant exists
      // for it (given the current upstream selection). Out-of-stock combinations
      // stay greyed so shoppers can tell what's available at a glance. Note this
      // is purely visual — the click handler still lets out-of-stock options be
      // selected (to request a quote); we only change how they look.
      var inStock = false;
      if (isBlocked) {
        var posEl = input.closest('[data-option-position]');
        if (posEl) {
          var changedPosition = parseInt(posEl.getAttribute('data-option-position'), 10);
          var upstream = getUpstream(optionGroups, changedPosition);
          var styleTarget = findTargetVariant(changedPosition, input.value, upstream, variants);
          inStock = !!(styleTarget && styleTarget.available);
        }
      }

      if (inStock) {
        // Restore the normal, selectable appearance (theme greys sold-out to
        // COLOR-A5 / COLOR-A20; the available look is transparent bg / inherit).
        label.style.setProperty('background-color', 'transparent', 'important');
        label.style.setProperty('color', 'inherit', 'important');
        label.style.setProperty('opacity', '1', 'important');
        if (span) span.classList.add('vf-selectable');
      } else {
        // Out of stock / unavailable — leave the theme's greyed styling in place
        // (still clickable via the document-level handler).
        label.style.removeProperty('background-color');
        label.style.removeProperty('color');
        label.style.removeProperty('opacity');
        if (span) span.classList.remove('vf-selectable');
      }
    });
  }

  function initCascade(container) {
    if (container._cascadeInit) return;
    container._cascadeInit = true;

    var variants = getVariants(container);
    if (!variants || !variants.length) return;

    // Keep option inputs un-blocked (Dawn-style). Watch for the theme/app
    // re-adding disabled or re-rendering the option DOM, and re-apply.
    var selectors = container.querySelector('[data-product-variants]') || container;
    var stripTimer;
    var mo = new MutationObserver(function () {
      clearTimeout(stripTimer);
      stripTimer = setTimeout(function () { unblockOptions(container, variants); }, 40);
    });
    mo.observe(selectors, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['disabled', 'class']
    });

    unblockOptions(container, variants);
    [150, 500, 1100, 1800, 2600].forEach(function (ms) {
      setTimeout(function () { unblockOptions(container, variants); }, ms);
    });
  }

  // Click handling is bound at DOCUMENT level in capture phase. A script on this
  // store (GPO / custom product code) has a capture-phase listener between the
  // document and the product section that calls stopPropagation, so a listener
  // on the section itself never fires. Document-capture runs before that, so we
  // catch the click reliably.
  function handleOptionClick(e) {
    var label = e.target.closest('label[for]');
    if (!label) return;

    var input = document.getElementById(label.getAttribute('for'));
    if (!input || input.type !== 'radio') return;
    if (!input.hasAttribute('data-single-option-selector')) return;

    var container = input.closest('[data-section-type="product"]');
    if (!container) return;
    var variants = getVariants(container);
    if (!variants || !variants.length) return;

    var isBlocked = input.classList.contains('sold-out') ||
                    input.classList.contains('unavailable') ||
                    input.disabled;
    if (!isBlocked) return; // normal available option — let the theme handle it

    var posEl = input.closest('[data-option-position]');
    if (!posEl) return;

    var changedPosition = parseInt(posEl.getAttribute('data-option-position'), 10);
    var optionGroups    = getOptionGroups(container);
    var upstream        = getUpstream(optionGroups, changedPosition);
    var target = findTargetVariant(changedPosition, input.value, upstream, variants);
    if (!target) return; // no real variant for this value — nothing to do

    e.preventDefault();
    e.stopPropagation();

    // Navigate to the target variant. The server re-renders the product with
    // this variant selected and all options/stock/ATC correct — the reliable
    // equivalent of Dawn's fetch-and-swap for a theme that requires a full
    // valid combination.
    var url = new URL(window.location.href);
    url.searchParams.set('variant', target.id);
    window.location.href = url.toString();
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="product"]').forEach(initCascade);
  }

  // Bind the document-level click handler once.
  document.addEventListener('click', handleOptionClick, true);

  document.addEventListener('DOMContentLoaded', initAll);
  setTimeout(initAll, 400);
})()
